import Vue from 'vue'
import Vuex from 'vuex'
import storLogin from './login/index.js'
import app from './modules/app'
import getters from './getters'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    name: 'main',
    breadListState: [{
      name: 'Home',
      path: '/admission/calendar'
    }],
    userInfo: {} // 用户信息
  },
  actions: {},
  mutations: {
    breadListStateAdd (state, obj) {
      state.breadListState.push(obj)
      localStorage.setItem('breadListStorage', JSON.stringify(state.breadListState))
    },
    breadListStateRemove (state, num) {
      state.breadListState = state.breadListState.slice(0, num)
      localStorage.setItem('breadListStorage', JSON.stringify(state.breadListState))
    },
    updateUserInfo: (state, userInfo) => {
      state.userInfo = userInfo
      sessionStorage.setItem('userInfo', JSON.stringify(state.userInfo))
    }
  },
  modules: {
    assets: storLogin,
    app
  },
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js